import Button, {
  DangerButton,
  GreyPrimaryAlternativeButton,
  PrimaryAlternativeButton,
  PrimaryBlueButton,
  PrimaryButton,
  SecondaryButton,
  SmallPrimaryButton,
} from './Button';
import { PrimaryExternalLink, PrimaryLink, SmallPrimaryExternalLink } from './ButtonLink';

export enum ButtonTypes {
  Button = 'Button',
  Primary = 'Primary',
  PrimaryBlue = 'PrimaryBlue',
  SmallPrimary = 'SmallPrimary',
  PrimaryAlternative = 'PrimaryAlternative',
  GreyPrimaryAlternative = 'GreyPrimaryAlternative',
  Danger = 'Danger',
  Secondary = 'Secondary',
  PrimaryLink = 'PrimaryLink',
  PrimaryExternalLink = 'PrimaryExternalLink',
  SmallPrimaryExternalLink = 'SmallPrimaryExternalLink',
}

export const buttons = {
  [ButtonTypes.Button]: Button,
  [ButtonTypes.Primary]: PrimaryButton,
  [ButtonTypes.PrimaryBlue]: PrimaryBlueButton,
  [ButtonTypes.SmallPrimary]: SmallPrimaryButton,
  [ButtonTypes.PrimaryAlternative]: PrimaryAlternativeButton,
  [ButtonTypes.GreyPrimaryAlternative]: GreyPrimaryAlternativeButton,
  [ButtonTypes.Danger]: DangerButton,
  [ButtonTypes.Secondary]: SecondaryButton,
  [ButtonTypes.PrimaryLink]: PrimaryLink,
  [ButtonTypes.PrimaryExternalLink]: PrimaryExternalLink,
  [ButtonTypes.SmallPrimaryExternalLink]: SmallPrimaryExternalLink,
};
